import { useMemo } from 'react';
import UniversalSaveBar from 'customer-data-properties/savebar/UniversalSaveBar';
// @ts-expect-error no types
import UnsavedChanges from 'customer-data-properties/savebar/UnsavedChanges';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TAB } from 'framework-asset-preview-lib/internal/shared/constants/assetPreview';
import { useInlineEdit } from 'framework-asset-preview-lib/internal/shared/providers/InlineEditProvider';
import AssetPreview from './AssetPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ConnectedAssetPreviewSidebar(props) {
  const {
    isDraft,
    onReset,
    onSave,
    formState,
    isLoading,
    hasErrors
  } = useInlineEdit();

  // The _fullWidthDisplay experience is used to display only the asset details in
  // a single, non-interactable view (PDF exports). Because of this the tabs are hidden.
  const tabs = useMemo(() => {
    if (props._fullWidthDisplay || props.hideTabs) {
      return [];
    }
    if (!props.tabs) {
      return [TAB.DETAILS, TAB.ASSETS];
    }
    return props.tabs;
  }, [props._fullWidthDisplay, props.hideTabs, props.tabs]);
  return /*#__PURE__*/_jsxs(UnsavedChanges, {
    changes: isDraft,
    errors: hasErrors,
    loading: isLoading,
    onCancel: onReset,
    onSave: onSave,
    children: [/*#__PURE__*/_jsx(UniversalSaveBar, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.saveBar.info",
        options: {
          count: Object.keys(formState).length
        }
      })
    }), /*#__PURE__*/_jsx(AssetPreview, Object.assign({}, props, {
      tabs: tabs
    }))]
  });
}